import styled from 'styled-components';

import { SimpleModalTitleStyled } from 'lib/modal/simple-modal.styles';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

export const TeachingLearningSequenceModalHeader = styled(
  SimpleModalTitleStyled
)`
  ${baseFlexCss}

  svg {
    margin-left: ${rem(spacing8)};
  }
`;
